class FaqAccordion extends HTMLElement {
  connectedCallback() {
    this.items = Array.from(this.querySelectorAll('.faq-item'));
    this.items.forEach((item) => {
      const summary = item.querySelector('.faq-item__summary');
      if (summary) {
        summary.addEventListener('click', () => this.toggle(item));
      }
    });
  }

  toggle(target) {
    const willOpen = !target.classList.contains('is-open');

    // Single-open: close every item first
    this.items.forEach((item) => {
      item.classList.remove('is-open');
      const summary = item.querySelector('.faq-item__summary');
      if (summary) summary.setAttribute('aria-expanded', 'false');
    });

    if (willOpen) {
      target.classList.add('is-open');
      const summary = target.querySelector('.faq-item__summary');
      if (summary) summary.setAttribute('aria-expanded', 'true');
    }
  }
}

if (!customElements.get('faq-accordion')) {
  customElements.define('faq-accordion', FaqAccordion);
}
